import React from 'react'
import Container from 'react-bootstrap/esm/Container'
import Button from './Button'

function Codathon() {
  return (
    <>
    <Container>
    <h1>
      Codathon
    </h1>
   <p> In a world increasingly dependent on technology, there will always be more coding to be done. Running a Codathon is one way to get massive amounts of brainstorming and coding finished in one day.
</p>
<p>When most people think of coding, they think of an introvert hiding behind a computer by themselves all day. Most people get into coding, so they don’t have to interact with other people.
</p>
<p>
But coding takes an enormous amount of creativity. Not many people can come up with an innovative project and code it into reality all in the same day!
</p><p>
The largest benefit of a Codathon, by far, is how empowered and inspired each coder feels after creating something from nothing.
</p>
If computer coding was a sport, Codathon would be matches. And the larger the Codathon is, the more it starts to feel like the Olympics.
<p>
Important highlights:
<br/> <br/>
Number of questions:6 <br/>
Platform: Codeforces<br/>
Time limit: 2hrs <br/>
Rules will be based on guidelines of ICPC.<br/>
The prize money for this event is worth ₹3500 and we also have exclusive prizes for first years.<br/>
</p>
<Button gformlink = 'https://forms.gle/CvhWUJUWk65jLGp96' />
</Container>
    </>
  )
}

export default Codathon